import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ValidationResult } from 'src/app/models/validation.result';
import { ApiService } from 'src/app/services/api.service';
import { Dictionary } from 'src/app/util/to-dictionary';

@Component({
  selector: 'app-bank-details-confirm',
  templateUrl: './bank-details-confirm.component.html',
  styleUrls: ['./bank-details-confirm.component.scss'],
})
export class BankDetailsConfirmComponent implements OnInit {

  @Input() key: string;
  @Input() answers: Dictionary<string>;
  @Output() back = new EventEmitter();
  @Output() continue = new EventEmitter<ValidationResult>();

  result: ValidationResult;
  loading = false;
  message: string = null;

  constructor(
    private api: ApiService
  ) { }

  ngOnInit() {
  }

  async verify() {
    this.message = 'Verifying your bank details...'
    this.loading = true;
    let retryCount = parseInt(this.answers["ValidationRetryCount"] ?? "0");
    try {
      const answers = Object.getOwnPropertyNames(this.answers)
        .map(key => ({ Key: key, Value: this.answers[key] }));

      this.result = await this.api.validateBank(this.key, answers);

      if (!this.result.valid) {
        retryCount += 1;
        this.answers["ValidationRetryCount"] = retryCount.toString();
        this.continue.emit(this.result);
      }
    } finally {
      this.loading = false;
    }
  }

}
